export default __webpack_public_path__ + "static/media/validate.1bcd7db4.svg";